import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import Toast from "cogo-toast";
import {DefaultLoader} from "../../../components/DefaultLoader";
import PageHeader from "../components/PageHeader";
import DeviceStatusChart from "./DeviceStatusChart";
import {apiGetTurnstile} from "./Actions";

const DeviceHistory = () => {
    const {id} = useParams();
    const [device, setDevice] = useState(null);
    const [loading, setLoading] = useState(false);
    const user = useSelector(s => s.user);

    useEffect(() => {
        if (id && user.activeAreal) {
            setLoading(true);
            apiGetTurnstile(user.activeAreal.id, id, (data) => {
                setDevice(data);
                setLoading(false);
            }, () => {
                Toast.error("Nepodařilo se načíst zařízení.");
                setLoading(false);
            });
        }
    }, [id, user.activeAreal]);

    return (
        <>
            <PageHeader crumbs={[
                {label: "Turnikety", to: "/turnstile"},
                {label: device ? (device.description || device.ipAddress) : "Historie zařízení"},
            ]}/>

            {loading ? <DefaultLoader text="Načítám zařízení..."/> : !device ? null : (
                <DeviceStatusChart deviceId={device.ipAddress}/>
            )}
        </>
    );
};

export default DeviceHistory;
